import React from 'react';

const UpgradeButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 12px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#cbd5e1',
        background: 'rgba(148, 163, 184, 0.1)',
        border: '1px solid #334155',
        borderRadius: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(148, 163, 184, 0.2)';
        e.currentTarget.style.borderColor = '#94a3b8';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(148, 163, 184, 0.1)';
        e.currentTarget.style.borderColor = '#334155';
      }}
    >
      <span style={{ fontSize: '12px' }}>🔒</span>
      Upgrade to unlock
    </button>
  );
};

export default UpgradeButton;
